import React from 'react';
import cs from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons';
import { faSquare, faSquareMinus } from '@fortawesome/pro-light-svg-icons';
import { intl } from 'shared/lib/intl';
import { BrkfstFile } from 'shared/typings/file';
import COLORS from 'shared/styles/colors';
import { Button } from 'shared/components/display';
import { BUTTON_VARIANTS } from 'shared/styles/button';

import styles from './styles';

interface Props {
  onSelectAllFilesClick: () => void;
  selectedFiles: BrkfstFile[];
  totalFiles: number;
}
const FileSelectAllButton: React.FC<Props> = ({ onSelectAllFilesClick, selectedFiles, totalFiles }) => {
  return (
    <Button
      css={styles}
      onClick={onSelectAllFilesClick}
      className={cs('file-select-all-button', {
        'file-select-all-button--none-selected': selectedFiles.length === 0,
      })}
      variant={BUTTON_VARIANTS.SECONDARY}
    >
      {selectedFiles.length === 0 && <NoneSelectedIndicator />}
      {selectedFiles.length > 0 && selectedFiles.length < totalFiles && <SomeSelectedIndicator />}
      {selectedFiles.length === totalFiles && totalFiles > 0 && <AllSelectedIndicator />}
      {intl.formatMessage({ id: 'BUTTON_SELECTED_FILES' }, { numFiles: selectedFiles.length })}
    </Button>
  );
};

export default FileSelectAllButton;

interface IconButtonProps {}

const NoneSelectedIndicator: React.FC<IconButtonProps> = ({}) => {
  return <FontAwesomeIcon icon={faSquare} className="file-select-all-button__icon" />;
};

const SomeSelectedIndicator: React.FC<IconButtonProps> = ({}) => {
  return <FontAwesomeIcon icon={faSquareMinus} className="file-select-all-button__icon" color={COLORS.NEUTRAL800} />;
};

const AllSelectedIndicator: React.FC<IconButtonProps> = ({}) => {
  return <FontAwesomeIcon icon={faSquareCheck} className="file-select-all-button__icon" color={COLORS.PRIMARY500} />;
};
